module.exports = __webpack_public_path__ + "img/anquan_gaoji-1.edf75017.png";